import script from "./OrgOrderPurchaseList.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrgOrderPurchaseList.vue?vue&type=script&setup=true&lang=ts"

import "./OrgOrderPurchaseList.vue?vue&type=style&index=0&id=55de131f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55de131f"]])

export default __exports__